////// JavaScript//////
import 'javascripts/portfolios/fb_share_link'

// node_modules
import 'chartkick'
import 'chart.js'

// flocss
import 'stylesheets/original/portfolios/index'
import 'stylesheets/original/portfolios/unpermitted_page'

// JavaScripts
import 'javascripts/portfolios/show'
